'use strict';

let module = {};

let routes = function ($stateProvider, baseState) {

    require('./routes.js').default.routes($stateProvider, '' + baseState + '');

    $stateProvider

        .state(baseState + '.clerk-tax-entities.existing.edit.configure-chart-of-accounts', {
            url: "/configure-chart-of-accounts",
            template: require("./steps/configure-chart-of-accounts.html"),
            data: {
                stepCaption: 'Configure chart of accounts',
            }
        })

        .state(baseState + '.clerk-tax-entities.existing.edit.inspect-chart-of-accounts', {
            url: "/inspect-chart-of-accounts",
            template: require("./steps/configure-chart-of-accounts.html"),
            data: {
                stepCaption: 'Inspect chart of accounts',
            }
        })

        .state(baseState + '.clerk-tax-entities.existing.edit.categorize-ledger-accounts', {
            url: "/categorize-ledger-accounts",
            template: require("./steps/configure-chart-of-accounts.html"),
            data: {
                stepCaption: 'Categorize ledger accounts',
            }
        })

    ;

};

module.routes = routes;

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-tax-entity/customized-routes.js